module.exports = __webpack_public_path__ + "static/img/qq.165422cd.png";